import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EndpointService {
  public getEndpointUrl(endpointUrl: string, urlParameters?: Map<string, string | number | boolean | Date>): string {
    if (urlParameters === undefined) {
      return endpointUrl;
    } else {
      urlParameters.forEach((value: string | number | boolean, param: string) => {
        const paramRegEx = new RegExp(`({${param}})`);
        endpointUrl = endpointUrl.replace(paramRegEx, value === null ? null : value.toString());
      });

      return endpointUrl;
    }
  }

  public getRequestParamsString(endpointUrl: string, queryParamters?: Map<string, object>): string {
    if (queryParamters === undefined) {
      return endpointUrl;
    } else {
      let finalEndpointUrl = endpointUrl;
      let first = true;
      queryParamters.forEach((value: object, key: string) => {
        if (first) {
          finalEndpointUrl += '?';
          first = false;
        } else {
          finalEndpointUrl += '&';
        }
        finalEndpointUrl += `${encodeURIComponent(key)}=${encodeURIComponent(
          value === null ? null : value.toString(),
        )}`;
      });
      return finalEndpointUrl;
    }
  }
}
